<ng-container #resultContainer>
    <div class="content-main">
        <div fxLayout="row" fxFlex="299px" fxFlex.xs="180px" fxFlex.sm="220px" class="sub-nav-search" fxLayoutAlign="start center" [formGroup]="taskSearchForm">
            <input class="sub-nav-search-input" placeholder="Search this board" formControlName="keyword" />
            <div class="sub-nav-search-image cp" (click)="resetSearch()">
                <img [src]="f.keyword.value ? '../../../../assets/image/svg/close-black.svg' : '../../../../assets/image/svg/search.svg'"
                    width="10px" [ngClass]="f.keyword.value ? 'close' : 'search'">
            </div>
        </div>
        
        <div class="search-dropdown-wrapper" *ngIf="f.keyword.value && f.keyword.value.length >= 3">
            <div class="search-dropdown" *ngIf="(taskList$ | async)?.loading">
                <div class="loading-state" fxLayout="row" fxLayoutAlign="center center">
                    Loading...
                </div>
            </div>

            <div class="search-dropdown" *ngIf="!(taskList$ | async)?.loading">    
                <!-- Tabs -->
                <div class="search-tabs" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                    <div class="tab" [class.active]="activeTab === 'all'" (click)="setActiveTab('all')">
                        All <span class="count">({{getCountByType('all')}})</span>
                    </div>
                    <div class="tab" [class.active]="activeTab === 'clients'" (click)="setActiveTab('clients')" *ngIf="hasClientViewPermission">
                        Clients <span class="count">({{getCountByType('client')}})</span>
                    </div>
                    <div class="tab" [class.active]="activeTab === 'projects'" (click)="setActiveTab('projects')">
                        Projects <span class="count">({{getCountByType('project')}})</span>
                    </div>
                    <div class="tab" [class.active]="activeTab === 'tasks'" (click)="setActiveTab('tasks')">
                        Tasks <span class="count">({{getCountByType('task')}})</span>
                    </div>
                </div>
    
                <!-- Results Table -->
                <div class="results-table" *ngIf="getFilteredItems().length > 0">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>                             
                                    <ng-container *ngIf="activeTab === 'clients' && hasClientViewPermission">
                                        <th>Client</th>
                                    </ng-container>
                            
                                    <ng-container *ngIf="activeTab === 'projects'">                                    
                                        <th>Project</th>
                                    </ng-container>                                
                                
                                    <ng-container *ngIf="activeTab === 'tasks'">
                                        <th>Task</th>
                                    </ng-container>                                
                                
                                    <ng-container *ngIf="activeTab === 'all'">
                                        <th *ngIf="hasClientViewPermission">Client</th>
                                        <th>Project</th>
                                        <th>Task</th>
                                    </ng-container>
                                    
                                    <!-- <th>Last Tracked</th> -->
                                    <th>Action</th>
                               
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of getFilteredItems()" (click)="navigateToItem(item, $event)">
                                    <!-- Clients Tab - Show only Client -->
                                    <ng-container *ngIf="activeTab === 'clients' && hasClientViewPermission">
                                        <td class="client-cell">
                                        <div class="client-info">
                                                <ngx-avatar size="32" [value]="item.clientName | firstletter"></ngx-avatar>
                                                <span>{{item.clientName}}</span>
                                            </div>
                                        </td> 
                                    </ng-container>
                                    
                                    <!-- Projects Tab - Show only Project -->
                                    <ng-container *ngIf="activeTab === 'projects'">
                                        <td class="client-cell">
                                            <div class="client-info">
                                                <ngx-avatar size="32" [value]="item.projectName | firstletter"></ngx-avatar>
                                                <span class="project-name" (click)="navigateToTimeLog(item.id)">{{item.projectName}}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    
                                    <!-- Tasks Tab - Show only Task -->
                                    <ng-container *ngIf="activeTab === 'tasks'">
                                        <td class="client-cell">
                                            <div class="client-info">
                                                <ngx-avatar size="32" [value]="item.taskName | firstletter"></ngx-avatar>
                                                <span>{{item.taskName}}</span>
                                            </div>                                        
                                        </td>
                                    </ng-container>
                                    
                                    <!-- All Tab - Show Client, Project, Task -->
                                    <ng-container *ngIf="activeTab === 'all'">
                                        <td class="client-cell" *ngIf="hasClientViewPermission" >
                                            <div class="client-info">
                                                <ngx-avatar size="32" *ngIf="item.clientName && item.clientName !== '-'" [value]="item.clientName | firstletter"></ngx-avatar>
                                                <span>{{item.clientName}}</span>
                                            </div>
                                        </td>
                                        <td class="client-cell">
                                            <div class="client-info">
                                                <ngx-avatar size="32" *ngIf="item.projectName && item.projectName !== '-'" [value]="item.projectName | firstletter"></ngx-avatar>
                                                <span class="project-name" (click)="navigateToTimeLog(item.id)">{{item.projectName}}</span>
                                            </div>
                                        </td>
                                        <td class="client-cell">
                                            <div class="client-info">
                                                <ngx-avatar size="32" *ngIf="item.taskName && item.taskName !== '-'" [value]="item.taskName | firstletter"></ngx-avatar>
                                                <span>{{item.taskName}}</span>
                                            </div>
                                        </td>
                                    </ng-container>      
                                    
                                    <td class="action-cell">
                                        <div class="action-buttons" fxLayout="row" fxLayoutGap="40px">
                                            <!-- Navigation Button -->
                                            <button class="action-btn" (click)="navigateToItem(item, $event)">
                                                {{item.entityType === 'project' ? 'Project' : item.entityType === 'client' ? 'Client' : 'Task'}}
                                            </button>
                                            
                                            <!-- Play/Stop Button - Shows only ONE based on entity type -->
                                            <div class="box-top-img cp">
                                                <!-- For Task type -->
                                                <ng-container *ngIf="item.entityType === 'task'">
                                                    <img src="../../../../assets/image/png/playblue.png" alt="" width="20px" *ngIf="!timerState || timerState.task_id !== item.id" (click)="initiateTask(item, 'start')">
                                                    <img src="../../../../assets/image/svg/stop-btn.svg" width="20px" *ngIf="timerState && timerState.task_id === item.id" (click)="initiateTask(item, 'stop')">
                                                </ng-container>
                                                
                                                <!-- For Client type -->
                                                <ng-container *ngIf="item.entityType === 'client'">
                                                    <img src="../../../../assets/image/png/playblue.png" alt="" width="20px" *ngIf="!timerState || timerState.entity_id !== item.id" (click)="createTimelog(item, 'CLIENT')">
                                                    <img src="../../../../assets/image/svg/stop-btn.svg" width="20px" *ngIf="timerState && timerState.entity_id === item.id" (click)="stopTimer()">
                                                </ng-container>
                                                
                                                <!-- For Project type -->
                                                <ng-container *ngIf="item.entityType === 'project'">
                                                    <img src="../../../../assets/image/png/playblue.png" alt="" width="20px" *ngIf="!timerState || timerState.entity_id !== item.id" (click)="createTimelog(item, 'PROJECT')">
                                                    <img src="../../../../assets/image/svg/stop-btn.svg" width="20px" *ngIf="timerState && timerState.entity_id === item.id" (click)="stopTimer()">
                                                </ng-container>
                                            </div>
                                        </div>
                                    </td>   
                                </tr>
                            </tbody>
                        </table>
                    </div>                   
            
                </div>
        
                <!-- No Results -->
                <div class="no-results" *ngIf="getFilteredItems().length === 0">
                    No results found for "{{f.keyword.value}}"
                </div>
            </div>
        </div>
    </div>
</ng-container>